'use strict';

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const fe=require('../../../dist-es6/shared/extensions/fatigueExtensions');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');let

RasterizationService=class RasterizationService extends BaseService{
static get $inject(){return['dateService']}

constructor(dateService){
super();
this._dateService=dateService;
}

rasterize(schedule,overallInterval,period,timeZone){
const schedulePeriods=overallInterval.getSpanningIntervals(period,1,timeZone);
const intervalsFilter=(intervals,schedulePeriod)=>intervals.filter(interval=>interval.intersects(schedulePeriod));

return schedulePeriods.map((schedulePeriod,index)=>{
const filtered={};

for(const series of['duties','flights','trips','sleep','sleepPromotingIntervals','pastShifts']){
filtered[series]=intervalsFilter(schedule[series],schedulePeriod);
}

for(const series of['fatigue','incidents']){
filtered[series]=schedule[series].filter(p=>schedulePeriod.contains(p.time));
}

filtered.assessments=schedule.assessments;

const now=this._dateService.now();
const nonAbuttingSchedulePeriod=TimeInterval.from(schedulePeriod.start).to(schedulePeriod.end.getTime()-1);
const dutyPeriodsIncludingForecast=TimeInterval.clip(filtered.duties.concat(schedule.forecastDutyInterval||[])).to(nonAbuttingSchedulePeriod);
const peakFatigue=fe(filtered.fatigue).peakConsistentWithFatigueApi(dutyPeriodsIncludingForecast);
fe.tagIfForecasted(peakFatigue,now);

return _.assign({
interval:schedulePeriod,
peakFatigue,
effectiveStatus:schedule.dailyEffectiveStatuses[index],
containsNow:schedulePeriod.contains(now)},
filtered);
});
}};


module.exports=RasterizationService;
//# sourceMappingURL=rasterizationService.js.map
